// extracted by mini-css-extract-plugin
export default {"root":"ProductGrid_root__OoLqf","row":"ProductGrid_row__oT-RR"};